














import Vue from "vue";

export default Vue.extend({
  name: "CategoryRequirements",

  props: {
    /**
     * Current category.
     */
    category: {
      type: Object as () => any,
      required: true,
    },

    /**
     * Current level.
     */
    level: {
      type: Number,
      required: true,
    },
  },

  computed: {
    levelDescription(): string {
      if (this.level === 0) {
        return this.$t("selfAssessment.assessment.defaultLevelDescription", {
          category: this.category.name,
        }) as string;
      }

      const description = this.category.categoryDetails.find(
        (item: any) => item.level.value === this.level,
      );

      const params = {
        description: description.requirements,
        level: this.level,
        category: this.category.name,
      };

      return this.$t(
        "selfAssessment.assessment.levelDescriptionTemplate",
        params,
      ) as string;
    },
  },
});
